import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import messageToast from "../../../components/messageToast/messageToast";
import { useLocation, useNavigate } from "react-router";
import { addConsumableMasterNew, updateConsumableMasterNew } from "../../../@app/subMaster/subMasterSlice";
import { EmployeeZone } from "../../../@app/master/masterSlice";
import { getOutlet } from "../../../@app/subMaster/subMasterSlice";
import { map } from "ramda";
import { Input, Card, Button, Radio, Col, Row, Form, Descriptions, message,Select } from "antd";
import { getDefinitionsList } from "../../../@app/subMaster/subMasterSlice";
import { useForm, Controller } from "react-hook-form";
import { transStatus } from "../../../util/transStatus";

function ConsumableMasterForm(mode) {
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const { Option } = Select;
  const [show, setShow] = useState(false);
  useEffect(() => {
    setShow(true);
  }, []);

  const {
    register,
    control,
    formState: { errors }
  } = useForm();

  const [messageApi, contextHolder] = message.useMessage();
  const navigate = useNavigate();
  const [outletType, setOutletType] = useState();
  const [channel, setChannel] = useState();
  const [category, setCategory] = useState();
  
  useEffect(() => {
    dispatch(getDefinitionsList());
  }, []);

  const {
    gettingDefinitionsList,
    getDefinitionsListResponse: { data: def }
  } = useSelector((state) => {
    return state.subMaster;
  });

  const onClickBack = () => {
    navigate("/consumableMasterNew");
  };
  
  const { state } = useLocation();
  const isEdit = state?.isEdit || false;
  let defaultValue = state?.data;

  if (defaultValue?.id) {
    form.setFieldsValue({ employee_image: defaultValue?.image ?? "No image" });
  }

  let newConsumableCode;
  const [consumableCode, setConsumableCode] = useState("");
  const onChangeConsumableCode = (e) => {
    newConsumableCode = e.target.value;
    setConsumableCode(newConsumableCode);
  };

  let newConsumableName;
  const [consumableName, setConsumableName] = useState("");
  const onChangeConsumableName = (e) => {
    newConsumableName = e.target.value;
    setConsumableName(newConsumableName);
  };

  let newQuantity;
  const [quantity, setQuantity] = useState("");
  const onChangeQuantity = (e) => {
    newQuantity = e.target.value;
    setQuantity(newQuantity);
  };

  const stateID = Form.useWatch("state_id", form); 
  const subZoneID = Form.useWatch("subzone_id", form);
  useEffect(() => {
    dispatch(EmployeeZone(stateID));
  }, [dispatch, stateID]);

  const [selectedOutlets, setselectedOutlets] = useState([]);

  useEffect(() => {
    dispatch(getOutlet(subZoneID));
  }, [dispatch, subZoneID]);

  useEffect(() => {
    dispatch(getOutlet());
  }, []);

  const {
    getOutletResponse: { data: outletMasterList }
  } = useSelector((state) => {
    return state.subMaster;
  });

  const outletList = outletMasterList?.map((o) => ({
    ...o,
    outlet_code: `${o?.outlet_code} - ${o?.name}`
  }));

  const [status, setStatus] = useState(defaultValue?.status ?? 1);

  const loginType = useSelector((state) => state.auth.type);
  const emp_map = useSelector(
    (state) =>
      state.auth.userData.data && state.auth.userData.data.employee_mapping
  );

  const onFinish = (data) => {
    const outlet = selectedOutlets;
    let id;
    if (defaultValue?.id) {
      id = defaultValue?.id;
    }
    dispatch(
      defaultValue?.id
        ? updateConsumableMasterNew({
            data: {
              ...data,
              status: transStatus({ status }),
              outlet_type: outletType ? outletType : state?.outlet_type_id,
              channel : channel ? channel : state?.channel,
              consumable_code: consumableCode ? consumableCode : state?.consumable_code,
              consumable_name: consumableName ? consumableName : state?.consumable_name,
              category : category ? category : state?.category,
              quantity: quantity ? quantity : state?.qty,             
              outlet_id: outlet,            
              id: id ? id : state?.id
            }
          })
        : addConsumableMasterNew({
            data: {
              ...data,
              outlet_id: outlet,
              outlet_type: outletType,
              channel : channel,
              consumable_code: consumableCode,
              consumable_name: consumableName,
              quantity: quantity, 
              category : category,          
              status: transStatus({ status })
            }
          })
    ).then(({ message, status, statusText }) => {
      if (status === 200) {
        messageToast({
          message: message ?? statusText,
          status,
          title: "Consumable Master Status"
        });
        navigate("/consumableMasterNew");
        form.resetFields();
      }
      if (status == 400) {
        messageApi.open({
          type: "warning",
          content: "Consumable Master already exists",
          className: "custom-class",
          style: {
            marginTop: "28vh",
            color: "#d91616",
            fontWeight: "bold"
          }
        });
        return false;
      }
    });
  };

  const { savingConsumableMaster } = useSelector((state) => {
    return state.subMaster;
  });

  return (
    <>
      <Card>
        {contextHolder}
        <Row style={{ justifyContent: "center" }}>
          <Col span={24}>
            <Form
              name="basic"
              labelCol={{ span: 24 }}
              wrapperCol={{ span: 24 }}
              initialValues={{
                status: defaultValue?.status === "Active" ? "1" : "0"
              }}
              onFinish={onFinish}
              form={form}
              autoComplete="off"
            >
              <Row gutter={[15, 0]}>
                <Descriptions bordered size="small">
                <Descriptions.Item
                    label={"Outlet Type"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px" }}
                  >
                    <Select
                      placeholder="Select"
                      style={{
                        width: "290px",                 
                        border: "2px solid #f5a60b",
                        borderRadius: "10px"
                      }}
                      name="outlet_type"
                      loading={gettingDefinitionsList}
                      onChange={(e) => setOutletType(e)}
                      defaultValue={defaultValue?.outlet_type}
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {map(
                        (state) => {
                          return (
                            <Option key={state.id} value={state.id}>
                              {state.def_list_name}
                            </Option>
                          );
                        },
                        def
                          ? def?.filter((e) => e.def_title == "Outlet Type")
                          : []
                      )}
                    </Select>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Channel"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px" }}
                  >
                    <Select
                      placeholder="Select"
                      style={{
                        width: "290px",                    
                        border: "2px solid #f5a60b",
                        borderRadius: "10px"
                      }}
                      name="channel"
                      loading={gettingDefinitionsList}
                      onChange={(e) => setChannel(e)}
                      defaultValue={defaultValue?.channel}
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {map(
                        (state) => {
                          return (
                            <Option key={state.id} value={state.id}>
                              {state.def_list_name}
                            </Option>
                          );
                        },
                        def
                          ? def?.filter((e) => e.def_title == "Channel")
                          : []
                      )}
                    </Select>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Outlet Name"}
                    style={{width: "130px"}}
                    className={`custom-background ${show ? "show" : ""}`}
                  >
                    <Col>
                      <Form.Item name="outlet_id">
                        <Controller
                          control={control}
                          name="outlet_id"
                          render={({ field }) => (
                            <Select
                            style={{ paddingTop:'16px',width: "290px"}}
                              {...register("outlet_id", {
                                required: mode === "add"
                              })}
                              disabled={mode === "edit"}
                              mode="multiple"
                              placeholder="Select"
                              maxTagCount={0}                       
                              showSearch
                              value={selectedOutlets}
                              {...field}
                              onChange={(selectedOutlets) => {
                                if (selectedOutlets.includes("select_all")) {                               
                                  field.onChange(
                                    outletList.map((outlet) => outlet.id)
                                  );                               
                                  setselectedOutlets(
                                    outletList.map((outlet) => outlet.id)
                                  );
                                } else if (
                                  selectedOutlets.includes("unselect_all")
                                ) {                               
                                  field.onChange([]);
                                } else {                                
                                  field.onChange(selectedOutlets);
                                  setselectedOutlets(selectedOutlets);
                                }
                              }}
                              filterOption={(input, option) =>
                                option.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >                           
                              <Option key="select_all" value="select_all">
                                Select All
                              </Option>
                              <Option key="unselect_all" value="unselect_all">
                                Unselect All
                              </Option>
                              {outletList &&
                                outletList
                                  .filter((e) => {
                                    if (loginType === 2) {
                                      let fid =
                                        emp_map &&
                                        emp_map.outlet.findIndex(
                                          (x) => Number(x.id) === Number(e.id)
                                        );
                                      return fid !== -1;
                                    } else {
                                      return true;
                                    }
                                  })
                                  .map((outlet) => (
                                    <Option key={outlet?.id} value={outlet?.id}>
                                      {outlet?.outlet_code}
                                    </Option>
                                  ))}
                            </Select>
                          )}
                        />
                      </Form.Item>
                    </Col>
                    {errors?.outlet_id && (
                      <p style={{ color: "red" }}>Please select Outlet</p>
                    )}
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Category"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px" }}
                  >
                    <Select
                      placeholder="Select"
                      style={{
                        width: "290px",                    
                        border: "2px solid #f5a60b",
                        borderRadius: "10px"
                      }}
                      name="category"
                      loading={gettingDefinitionsList}
                      onChange={(e) => setCategory(e)}
                      defaultValue={defaultValue?.material_group}
                      showSearch
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {map(
                        (state) => {
                          return (
                            <Option key={state.id} value={state.id}>
                              {state.def_list_name}
                            </Option>
                          );
                        },
                        def
                          ? def?.filter((e) => e.def_title == "Category")
                          : []
                      )}
                    </Select>
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Consumable Code"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px" }}
                  >
                    <Input
                      name="consumable_code"
                      onChange={onChangeConsumableCode}
                      defaultValue={defaultValue?.consumable_code}
                      style={{ width: "300px" }}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Consumable Name"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px",height:"70px" }}
                  >
                    <Input
                      name="consumable_name"
                      onChange={onChangeConsumableName}
                      defaultValue={defaultValue?.consumable_name}
                      style={{ width: "300px" }}
                    />
                  </Descriptions.Item>
                  <Descriptions.Item
                    label={"Quantity"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "140px",height:"80px" }}
                  >
                    <Input
                      name="qty"
                      onChange={onChangeQuantity}
                      defaultValue={defaultValue?.uom}
                      style={{ width: "290px"}}
                    />
                  </Descriptions.Item>              
                  <Descriptions.Item
                    label={"* Status"}
                    className={`custom-background ${show ? "show" : ""}`}
                    style={{ width: "120px", color: "#f70707" }}
                    name="status"
                  >
                    <Radio.Group
                      buttonStyle="solid"
                      onChange={(e) => {
                        setStatus(e?.target?.value);
                      }}
                      size="small"
                      defaultValue={
                        defaultValue?.status === "In Active" ? 0 : 1
                      }
                    >
                      <Radio.Button className="active" value={1}>
                        Active
                      </Radio.Button>
                      <Radio.Button className="in-active" value={0}>
                        In-Active
                      </Radio.Button>
                    </Radio.Group>
                  </Descriptions.Item>
                </Descriptions>
                <Col span={24}>
                  <Row gutter={[15, 15]} style={{ justifyContent: "end" }}>
                    <Col
                      span={12}
                      style={{ textAlign: "right" }}
                      className="d-flex align-items-center justify-content-end mt-3"
                    >
                      <Form.Item className="mx-2">
                        <Button
                          loading={savingConsumableMaster}
                          className="orangeFactory"
                          type="primary"
                          htmlType="submit"
                        >
                          {isEdit ? "Update" : "Add"}
                        </Button>
                      </Form.Item>                  
                      <Form.Item>
                        <Button onClick={onClickBack}>Back</Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      </Card>
    </>
  );
}

export default ConsumableMasterForm;
